
import React from "react";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export interface FilterChipsProps {
    value: string;
    options: [string, string][];
    onChange: (value: string) => void;
}

function FilterChips({ value, options, onChange }: FilterChipsProps) {
    return (<div className={styles["chips"]} role="tablist">
        {options.map(([v, label]) => (
            <button key={v} role="tab" aria-selected={value === v} className={Classname.build(styles["chip"], { [styles["active"]]: value === v })} onClick={() => onChange(v)}>{label}</button>
        ))}
    </div>);
}

export default FilterChips;
